var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("403 Sinulla ei ole oikeutta tarkastella kyseistä sivua.")])}
var staticRenderFns = []

export { render, staticRenderFns }